var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#300096"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.752 0 0 10.752 0 24s10.752 24 24 24 24-10.752 24-24S37.248 0 24 0Zm2.4 36h-4.8V21.6h4.8V36Zm0-19.2h-4.8V12h4.8v4.8Z",
    fill: "#E7DBFF"
  })));
};
export default SvgInfo;